import React, { useState } from 'react';
import { Flex } from 'reflexbox';
import styled from 'styled-components';
import { ActionButton } from './components/AccountDetailsComponents';
import { isValidEmailAddress } from '../../helpers';

const AddEmailContact = ({ onSubmit, onCancel, placeholder = 'Add Email Contact' }) => {
  const [emailContact, setEmailContact] = useState('');

  const addEmailContactHandler = setFunction => e => {
    const { value } = e?.target;
    setFunction(() => value);
  };

  const emailContactSubmitHandler = e => {
    e.preventDefault();
    onSubmit(emailContact.trim());
  };

  return (
    <EmailContactForm onSubmit={emailContactSubmitHandler}>
      <EmailContactInput
        placeholder={placeholder}
        value={emailContact}
        onChange={addEmailContactHandler(setEmailContact)}
      />
      <ButtonContainer>
        <ActionButton
          disabled={!isValidEmailAddress(emailContact.trim())}
          type='submit'>
          Add
        </ActionButton>
        <ActionButton onClick={onCancel} type='button'>Close</ActionButton>
      </ButtonContainer>
    </EmailContactForm>
  );
};

const EmailContactForm = styled.form`
  position: relative;
  min-height: 90px;
`;

const EmailContactInput = styled.input`
  padding: 16px 2px 2px  2px;
  width: 80%;
  background: none;
  border: none;
  outline: none;
  border-bottom: 1px solid black;
  font-size: 16px;
`;

const ButtonContainer = styled(Flex)`
  width: 30%;
  left: 0;
  bottom: 0;
  transform: translateY(110%);
  justify-content: space-between;
  margin-bottom: 10px;
`;

export default AddEmailContact;
